// Human Atlas engine (MIT, atlas/Human-Atlas), converted from TypeScript for the Doctolik Atlas plugin.
async function decodeModelResponse(response, expectedBytes, compressed) {
  if (!response.ok) throw new Error("An anatomy file could not be loaded.");
  const payload = await response.arrayBuffer(), signature = new Uint8Array(payload, 0, Math.min(2, payload.byteLength));
  const gzip = compressed && signature[0] === 31 && signature[1] === 139;
  const buffer = gzip ? await new Response(new Blob([payload]).stream().pipeThrough(new DecompressionStream("gzip"))).arrayBuffer() : payload;
  if (buffer.byteLength !== expectedBytes) throw new Error("An anatomy file was incomplete. Please reload the viewer.");
  return buffer;
}
// Manifests and chunks reference "/models/..."; the model files are deployed
// with the SPA under public/plugins/atlas/models.
const MODELS_BASE = `${(import.meta.env?.BASE_URL ?? "/").replace(/\/$/, "")}/plugins/atlas`;
function asset(path) {
  return path.startsWith("/") ? MODELS_BASE + path : path;
}
export {
  asset,
  decodeModelResponse
};
